export default __webpack_public_path__ + "static/media/Selected_Head_Bounce.b95ab3fc.svg";